import { Content } from "@robe/core/src/types/content";
import { useData } from "./useData";

/**
 * @returns returns the content of the current page
 */
export const usePageContent = <TSource extends Content>(): TSource => {
  const { pageContent } = useData<TSource>();

  return pageContent;
};
